export const ads = [
  <div className="sticky-sidebar-ad" id="snack-sidebar-outer">
    <div id="snack-sidebar-3" />
  </div>,
  <div className="sticky-sidebar-ad" id="snack-sidebar-outer">
    <div id="snack-sidebar-2" />
  </div>,
  <div className="sticky-sidebar-ad" id="snack-incontent-1" />,
  <div className="sticky-sidebar-ad" id="snack-incontent-2" />,
  <div className="sticky-sidebar-ad" id="snack-incontent-3" />,
  <div className="sticky-sidebar-ad" id="snack-incontent-repeater" />,
];
